import { useEffect, useState, useContext } from "react";
import {Card,ListGroup,Button,Modal,Form, FormGroup} from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { BsFillPlusSquareFill, BsFillPencilFill} from "react-icons/bs";
import $ from "jquery";
import {
  useNavigate
} from "react-router-dom";
import UserContext from "../../contexts/UserContext";

const Menu = () => {
  const navigate = useNavigate();
    const [date,setDate] = useState([])
    const [days,setDays] = useState([]);
    const [show, setShow] = useState(false);
    const [inputData,setInputData] = useState([]);
    const [currentDate,setCurrentDate] = useState();
    const [currentDay,setCurrentDay] = useState();
    const [noThaali,setNoThaali] = useState(false);
    const {user,setUser} = useContext(UserContext);
    const [isLoading, setLoading] = useState(true);
    let count=0;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  async function getData(userId){
    await $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
        if(response && response.user){
           setUser(response.user);
        }else{
          setUser(null)
          navigate("/login",{state: { message: response.message }})
        }

      },
      error: function(err){
          console.log("error")
          console.log(err)
      }
  })
  }

    const editMenu = (day,date) => {
      setInputData([])
      if(day.items.length && !day.items[0].label){
        setNoThaali(false);
      }else{
        setNoThaali(true)
      }
        handleShow();
        day.items.map((item) => {
          setInputData(day.items);
        })
        setCurrentDate(date);
        setCurrentDay(day.day)
    }

    function getMenu(){
      $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/menus",
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : function(response){
          if(response.days){
          setDays(response.days)
          setDate(response.dates)
          setLoading(false)
        }else{ 
          navigate("/login");
        }
          
        },
        error: function(err){
            console.log("error")
            console.log(err)
            navigate("/login")
        }
      })
    }

    const updateData = (event) => {
      event.preventDefault();
      let selectedMenu = [];
      Array.prototype.slice.call(event.target.childNodes).map((currentEl)=>{
        if(currentEl.lastElementChild){
          if(currentEl.lastElementChild.className==='form-control'){
            selectedMenu.push(currentEl.childNodes[1].value)
          }
        }        
      })
      days.find(
        (day)=>{
          if(day.day === currentDay){
            day.items=selectedMenu;
            if(noThaali && event.target.comment.value.length>0){
              day.items = [{label:event.target.comment.value}]
            }
            $.ajax({
              type:"PUT",
              url:process.env.REACT_APP_API_URL+"/updateMenu",
              data:{day},
              dataType: 'json',
              xhrFields: {
                  withCredentials: true  // Include cookies
                },
                crossDomain: true, 
               success : function(response){
                if(response.message  && response.message.includes("Error in auth")){
                navigate("/login");
              }
                setDays(response.days)
                if(response.user){
                  setUser(response.user)
                }
                
              },
              error: function(err){
                  console.log("error")
                  console.log(err)
              }
            })
          }
        }
        )
        handleClose();
        setInputData([]);
          
    }

    const addItem = () => {
      setNoThaali(false);
      setInputData((data)=>{
        return [
          ...data,
          ''
        ]
      })
    }

    function getDaysInMonth(month, year) {
        var date = new Date(year, month, 1);
        var days = [];
        while (date.getMonth() === month) {
          days.push({date:new Date(date),menu:['Chicken','Mutton']});
          date.setDate(date.getDate() + 1);
        }
        return days;
      }
     
    const Dates = (key) => {
        const dateDesign=(
            <>
                {
                days.map((day,i)=>{
                    return <>
                        <Card key={i} className="mb-4 mx-3">
                        <Card.Header>{date[i+1]}</Card.Header>
                        <ListGroup variant="flush">
                            {
                              day.items.length>0 && !day.items[0].label?
                                day.items.map((items,i)=>{
                                    return <ListGroup.Item key={i}>{items}</ListGroup.Item>
                                }):
                                <ListGroup.Item>No Thaali {day.items[0] && day.items[0].label && day.items[0].label.length>0 ? '- '+ day.items[0].label.toString(): null }</ListGroup.Item>
                            }
                        </ListGroup>
                            {user && user.role==='admin'?<Card.Link onClick={()=>{editMenu(day,date[i+1])}} href="#" className="m-2 svg-color"><BsFillPencilFill className="ms-2 svg-color"/> Change Menu</Card.Link>:null}
                        </Card>
                    </>
                })
                }
            </>
        )
        return dateDesign;
    }

    const disableMenus = (e) => {
      if(noThaali){
        setNoThaali(false)
      }else{
        setInputData([]);
        setNoThaali(true)
      }
    }

    useEffect(()=>{
      try{
      if(!user && localStorage.getItem('userSession')){
        getData(JSON.parse(localStorage.getItem('userSession')))
      }else{
        if(!user){
          navigate("/login")
        }
      }
    }catch(e){
      if(!user){
        navigate("/login")
      }
    }
      getMenu();
    },[])
    const design = (
        <>
        <h6 className="m-3 mx-auto" style={{width:'50%'}}>Menu For the Week</h6>
        <Dates key={count++} />

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Menu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentDate==null ?null: currentDate}<br/><br/>
          <Form id="menuForm" onSubmit={updateData}>
            {
              inputData.map((inputElement,i)=>{
                if(!inputElement.label){
                return <Form.Group className="mb-3">
                  <Form.Label>Menu item</Form.Label>
                  <Form.Control name={'menu' +(i+1)} type="text" defaultValue={inputElement?inputElement:null} placeholder={'Enter Menu item'} />
                </Form.Group>
                }
              })
            }
            {noThaali?<Form.Group className={noThaali?'d-block mb-3':'d-none'}>
                <Form.Label>Comments</Form.Label>
                <Form.Control name='comment' type="text" defaultValue={inputData[0]&&inputData[0].label ? inputData[0].label : null} placeholder='Urs / Miqaat / Other Events'/>
            </Form.Group>:null}
            <Form.Group>
            <Form.Check // prettier-ignore
            type='checkbox'
            label='No thaali'
            checked={noThaali}
            onClick={disableMenus}
          />
            </Form.Group>

            <BsFillPlusSquareFill  fill="#361e17" style={{width:"32px",height:"28px",float:"right"}} onClick={addItem} /><br/>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
          </Modal.Body>
      </Modal>
        </>
    )
    return isLoading? <div className="mx-auto mt-5" style={{width: "30px"}}><Spinner className="mx-auto " style={{color:'brown'}} animation="border" role="status">
    </Spinner><br/>
    <span style={{marginLeft:'-10px'}}>Loading...</span></div>: design;
} 

export default Menu;
